import { autoserializeAs, inheritSerialization } from 'cerialize';
import { Driver } from './driver';
import { FavoriteLocation } from './favorite-location';

import { Person } from './person';

@inheritSerialization(Person)
export class Rider extends Person {
  @autoserializeAs(Driver)
  favoriteDrivers: Array<Driver>;

  @autoserializeAs(FavoriteLocation)
  favoriteLocations: Array<FavoriteLocation>;

  ignoredDrivers: Array<Driver> = [];
}
